import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./ContactFloatingIcons.css";

// Placeholder icon images (replace with your actual assets)
import icon1 from "../../../assets/contactsection/google.png";
import icon2 from "../../../assets/contactsection/facebook.png";
import icon3 from "../../../assets/contactsection/telegram.png";
import icon4 from "../../../assets/contactsection/twitter.png";
import icon5 from "../../../assets/contactsection/whatsapp.png";
import icon6 from "../../../assets/contactsection/viber.png";

const ContactFloatingIcons = () => {
  const sectionRef = useRef(null);
  // For fade-in/fade-out on scroll
  const isInView = useInView(sectionRef, {
    margin: "-100px 0px -100px 0px",
    once: false,
  });

  return (
    <section ref={sectionRef} className="floating-icons-section">
      {/* Fade container */}
      <motion.div
        className="fi-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{ duration: 0.7 }}
      >
        {/* Floating Icons: absolute images around the container */}
        <div className="fi-icon icon1">
          <img src={icon1} alt="Icon 1" />
        </div>
        <div className="fi-icon icon2">
          <img src={icon2} alt="Icon 2" />
        </div>
        <div className="fi-icon icon3">
          <img src={icon3} alt="Icon 3" />
        </div>
        <div className="fi-icon icon4">
          <img src={icon4} alt="Icon 4" />
        </div>
        <div className="fi-icon icon5">
          <img src={icon5} alt="Icon 5" />
        </div>
        <div className="fi-icon icon6">
          <img src={icon6} alt="Icon 6" />
        </div>

        {/* Main Text Centered */}
        <div className="fi-center-content">
          <h2 className="fi-heading">
            Let's talk about your project and see how we can work together
          </h2>
          <p className="fi-subheading">
            Our team of designers, developers and creatives are perfectionists
            who love what they do and love where they work
          </p>
          <button className="fi-button">Contact Us</button>
        </div>
      </motion.div>
    </section>
  );
};

export default ContactFloatingIcons;